import React, { useContext, useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router";
// import { Redirect } from "react-router/dom";
import './App.css';

import { userContext } from './components/Context'

import Navbar from './views/Navbar'
import Login from './views/users/Login'
import AppsIndex from './views/apps/AppsIndex'
import AppView from './views/apps/AppView'
import DevicesIndex from './views/devices/DevicesIndex'
import GroupsIndex from './views/groups/GroupsIndex'
import GroupView from './views/groups/GroupView'

import { connect, disconnect, subscribeToDevices } from './Socket'


function App() {
  const ctx = useContext(userContext)
  const [devices, setDevices] = useState([])

  useEffect(() => {
    connect()

    subscribeToDevices((err, data) => {
      if(err) return
      setDevices(data)
    })

    return () => {
      disconnect()
    }
  }, [])

  return (
    <div className="App">
      <Router>
        <Navbar />
        <div className="page">
          <Routes>
            {ctx ? (
              <>
              <Route index element={<Navigate to="/apps" replace />} />

              <Route exact path="/apps" element={<AppsIndex />} />

              <Route path="/app/:id" element={<AppView />} />

              <Route exact path="/groups" element={<GroupsIndex />} />

              <Route path="/groups/:group_id" element={<GroupView />} />

              <Route exact path="/devices" element={<DevicesIndex devices={devices}/>} />
              </>
            ) : (
              <>
              <Route index element={<Navigate to="/login" replace />} />
              <Route exact path="/login" element={<Login  />} />
              </>
            )}
          </Routes>
        </div>
      </Router>
    </div>
  )
}


export default App;
